export const getApiUrl = () => {
  return import.meta.env.VITE_API_URL || '/api';
};

export const getMapboxToken = () => {
  return import.meta.env.VITE_MAPBOX_TOKEN || '';
};

// East TX 10 m slope drape (XYZ PNG, built by scripts/build-slope-tiles.sh). In prod
// this points at the R2 prefix beside the slope COGs; unset it falls back to the local
// build symlinked into public/, so dev works without R2 credentials.
export const getSlopeTilesUrl = () => {
  // Absolute, like getWetlandsTileUrl — Mapbox GL does not resolve a relative
  // tile template against the document base.
  return import.meta.env.VITE_SLOPE_TILES_URL || `${window.location.origin}/etx-slope`;
};

// 1 m per-site slope drape (scripts/build-site-slope-tiles.sh). Covers only the
// shortlist campus footprints — the 10 m layer stays the regional screen.
export const getSlope1mTilesUrl = () => {
  return import.meta.env.VITE_SLOPE_1M_TILES_URL || `${window.location.origin}/site-slope-1m`;
};
